import { readPaymentList } from '../../Common/api/paymentResultRead';
import PaymentStatusFilter from '../../Common/components/PaymentStatusFilter';
import PaymentResultMonitor from '../../Common/components/PaymentResultMonitor';
import { showUnknownPayment, isUnknownPayment, unknownPaymentLabel, safePaymentResultMessage, paymentResultFields } from '../../Common/utils/paymentResult';
import { useDispatch } from 'react-redux';
import '../../Common/css/app.css';
import '../../Common/css/main.css';
import '../../Common/css/common.css';
import '../../Common/css/payment.css';
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { change_Current_Location, changeHeaderTitle } from '../../Common/store.js';
import axios from 'axios';
import { CalendarDays, ChevronDown, ChevronLeft, Check, Clock, Download, X, AlertTriangle, Search, ReceiptText } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileInvoice, faCheck } from "@fortawesome/free-solid-svg-icons";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import DatePicker from 'react-datepicker';
import { ko } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import ReceiptPreviewModalV2 from '../../Common/components/receipt/ReceiptPreviewModalV2';
import { resolveUnmeReceiptInfo, receiptSendError } from '../../Common/api/unmeReceiptInfo';
import ReceiptImageActions from '../../Common/components/receipt/ReceiptImageActions';
import { RECEIPT_UI_VERSION } from '../../Common/config/receiptUi';
import { RECEIPT_CARD_SMS_NOTICE, RECEIPT_LABELS } from '../../Common/constants/receiptLabels';
import { BRAND_COPYRIGHT } from '../../Common/config/brandConfig';
import { downloadBlob, getDemoPaymentBlockMessage, isDemoPaymentBlocked } from '../../Common/api/client';
import useManualPaymentConfig from '../../Common/hooks/useManualPaymentConfig';
import DemoModeBanner from '../components/DemoModeBanner';
import { isUnmePaymentRecovery, withUnmePaymentRecoveryParams } from '../../Common/utils/unmePaymentRecovery';

dayjs.extend(utc);

// 영업자 앱 결제내역에서 전표 미리보기를 사용할지 여부
const APP_RECEIPT_VIEW_MODE = Number(process.env.REACT_APP_APP_RECEIPT_VIEW_MODE ?? 1);

const RECEIPT_SMS_ENABLED = Number(process.env.REACT_APP_RECEIPT_SMS_ENABLED ?? 0) === 1;
const RECEIPT_KAKAO_ENABLED = Number(process.env.REACT_APP_RECEIPT_KAKAO_ENABLED ?? 0) === 1;
const TRANSACTION_STATUS_LABELS = {
    COMPLETED: "승인",
    CANCELED: "취소",
    FAILED: "실패",
    REQUESTED: "요청 중",
    APPROVED: "승인 처리 중",
};
const PAYMENT_PAGE_SIZE = 100;

const APP_RECEIPT_SUPPLIER_MOCK = {
    supplierName: "엔토스페이먼츠",
    supplierOwnerName: "-",
    supplierBusinessNo: "123-45-67890",
    supplierContact: "1661-0000",
    supplierAddress: "서울특별시 강남구 테헤란로 100",
};
const APP_RECEIPT_MERCHANT_MOCK = {
    merchantName: "유앤미케어",
    merchantOwnerName: "이영업",
    merchantBusinessNo: "987-65-43210",
    merchantContact: "02-1234-5678",
    merchantAddress: "서울특별시 서초구 반포대로 10",
};
const APP_RECEIPT_CARD_MERCHANT_MOCK = {
    cardMerchantName: "유앤미케어카드가맹점",
    cardMerchantOwnerName: "이영업",
    cardMerchantBusinessNo: "987-65-43210",
    cardMerchantContact: "-",
    cardMerchantAddress: "-",
};

// UTC → 한국시간(KST, UTC+9) 포맷
function formatKST(dateStr, format = "HH:mm") {
    if (!dateStr) return "-";
    return dayjs.utc(dateStr).add(9, "hour").format(format);
}

// API 응답 pg_raw_response에서 카드명 추출
function parseCardNameFromRaw(pgRawResponse) {
    if (!pgRawResponse || typeof pgRawResponse !== "string") return "-";
    try {
        const parsed = JSON.parse(pgRawResponse);
        const data = parsed?.data;
        return data?.cardNm || data?.cardKind || "-";
    } catch (_) {
        return "-";
    }
}

function mapPaymentToTransaction(item) {
  const paymentTransactionId =
    item.payment_transaction_id ??
    item.paymentTransactionId ??
    item.id ??
    item.paymentId ??
    item.payment_id;
  const id =
    item.transaction_id ??
    item.transactionId ??
    [
      paymentTransactionId ?? "payment",
      item.transaction_type ?? item.transactionType ?? "UNKNOWN",
      item.business_created_at ?? item.businessCreatedAt ?? "",
    ].join(":");
  const businessDate =
    item.business_created_at ??
    item.businessCreatedAt;
  const dateStr =
    businessDate ??
    item.approved_at ??
    item.approvedAt ??
    item.approval_date ??
    item.approvalDate ??
    item.created_at ??
    item.createdAt ??
    item.date;
    const date = dateStr
      ? businessDate
        ? dayjs.utc(dateStr).subtract(9, "hour").toISOString()
        : dayjs.utc(dateStr).toISOString()
      : dayjs().toISOString();
  // 할부개월 필드 (cp manual / pg 공통 후보)
  const instmtMon =
    item.instmt_mon ??
    item.instmtMon ??
    item.pg_instmt_mon ??
    item.installmentMonths ??
    item.installment_months ??
    "00";
    const type = instmtMon === "00" ? "일시불" : `${instmtMon}개월`;
  const cardNoMasked =
    item.card_no_masked ??
    item.cardNoMasked ??
    item.maskedCardNo ??
    item.masked_card_no ??
    "-";
  const cardName =
    item.card_nm ??
    item.cardNm ??
    item.cardName ??
    parseCardNameFromRaw(item.pg_raw_response) ??
    "-";
  const status = item.status ?? "";
  const transactionType = String(
    item.transaction_type ?? item.transactionType ?? ""
  ).toUpperCase();
  const transactionStatus = isUnknownPayment(item) ? 'UNKNOWN' : item.transaction_status ?? item.transactionStatus ?? '';
    return {
    ...paymentResultFields(item),
        id,
    // 취소/전표에서 공통으로 사용할 paymentTransactionId를 명시적으로 보관
    paymentTransactionId,
    receiptTransactionId: item.transaction_id ?? item.transactionId ?? item.payment_transaction_id ?? item.paymentTransactionId,
    paymentId: paymentTransactionId,
        date,
    pgProvider: item.pg_provider ?? item.pgProvider ?? '',
    pharmacy:
      item.transaction_pharmacy_name ??
      item.transactionPharmacyName ??
      item.mcht_cust_nm ??
      item.mchtCustNm ??
      item.pharmacy ??
      item.customer_name ??
      item.pharmacy_name ??
      item.customerName ??
      item.pharmacyName ??
      "-",
    amount: Number(
      item.amount ??
        item.trdAmt ??
        item.trd_amt ??
        item.pg_trd_amt ??
        item.request_trd_amt ??
        0
    ),
        approvalNo: item.appr_no ?? item.apprNo ?? item.approvalNo ?? item.approval_no ?? item.approvalNumber ?? "",
        type,
        status,
        transactionType,
        transactionStatus,
        cancelStatus:
          String(status).toUpperCase() === "CANCELED" ||
          item.canceled_at != null,
        canceledAt: item.canceled_at ?? item.canceledAt ?? null,
        cardName,
        cardNoMasked,
        isDemo: item.isDemo === true || item.is_demo === true,
    };
}

function getStatusLabel(tx) {
  if (isUnknownPayment(tx)) return unknownPaymentLabel(tx);
    const status = String(tx.transactionStatus || "").toUpperCase();
    return TRANSACTION_STATUS_LABELS[status] || tx.transactionStatus || "-";
}

function getKstToday() {
    return dayjs.utc().add(9, "hour").format("YYYY-MM-DD");
}

function formatFilterDate(value) {
    if (!value) return "";
    const date = dayjs(value);
    const currentYear = dayjs(getKstToday()).year();
    return date.year() === currentYear ? date.format("MM.DD") : date.format("YY.MM.DD");
}

function parseInputDate(value) {
    if (!value) return null;
    const [year, month, day] = String(value).split("-").map(Number);
    if (!year || !month || !day) return null;
    return new Date(year, month - 1, day);
}

function formatInputDate(value) {
    if (!(value instanceof Date) || Number.isNaN(value.getTime())) return "";
    return [
        value.getFullYear(),
        String(value.getMonth() + 1).padStart(2, "0"),
        String(value.getDate()).padStart(2, "0"),
    ].join("-");
}

function mergeTransactions(current, incoming) {
    const merged = new Map(current.map((tx) => [String(tx.id), tx]));
    incoming.forEach((tx) => merged.set(String(tx.id), tx));
    return Array.from(merged.values());
}

function createDemoTransactions({ search = "", dateFrom = "", dateTo = "" } = {}) {
    const approvalAt = dayjs.utc().subtract(35, "minute").toISOString();
    const canceledAt = dayjs.utc().subtract(1, "day").subtract(20, "minute").toISOString();
    const rows = [
        {
            transaction_id: "demo-approval-1",
            payment_transaction_id: "demo-payment-1",
            transaction_type: "APPROVAL",
            transaction_status: "COMPLETED",
            status: "COMPLETED",
            approved_at: approvalAt,
            transaction_pharmacy_name: "해피약국 (시연)",
            amount: 125000,
            appr_no: "90000001",
            card_nm: "시연카드",
            card_no_masked: "****-****-****-0001",
            instmt_mon: "00",
            is_demo: true,
        },
        {
            transaction_id: "demo-cancel-1",
            payment_transaction_id: "demo-payment-2",
            transaction_type: "CANCEL",
            transaction_status: "COMPLETED",
            status: "CANCELED",
            approved_at: canceledAt,
            canceled_at: canceledAt,
            transaction_pharmacy_name: "새봄약국 (시연)",
            amount: 78000,
            appr_no: "90000002",
            card_nm: "시연카드",
            card_no_masked: "****-****-****-0002",
            instmt_mon: "00",
            is_demo: true,
        },
    ].map(mapPaymentToTransaction);

    const keyword = String(search || "").trim().toLowerCase();
    return rows.filter((tx) => {
        const transactionDate = dayjs.utc(tx.date).add(9, "hour").format("YYYY-MM-DD");
        if (keyword && !String(tx.pharmacy || "").toLowerCase().includes(keyword)) return false;
        if (dateFrom && transactionDate < dateFrom) return false;
        if (dateTo && transactionDate > dateTo) return false;
        return true;
    });
}

function summarizeDemoTransactions(rows) {
    const approvals = rows.filter((tx) => tx.transactionType === "APPROVAL");
    const cancels = rows.filter((tx) => tx.transactionType === "CANCEL");
    const approvalAmount = approvals.reduce((sum, tx) => sum + Math.abs(Number(tx.amount || 0)), 0);
    const cancelAmount = cancels.reduce((sum, tx) => sum + Math.abs(Number(tx.amount || 0)), 0);
    return {
        transactionCount: rows.length,
        approvalCount: approvals.length,
        cancelCount: cancels.length,
        failedCount: 0,
        approvalAmount,
        cancelAmount,
        netPaymentAmount: approvalAmount - cancelAmount,
    };
}

function AppPaymentList() {
    const manualPaymentConfig = useManualPaymentConfig('terminal');
    const demoMode = manualPaymentConfig.demoMode === true
        || (typeof window !== "undefined" && window.sessionStorage?.getItem("terminal_demo_mode") === "true");
    const cancelBlocked = manualPaymentConfig.loading || manualPaymentConfig.paymentEnabled === false;
    const cancelBlockReason = manualPaymentConfig.paymentBlockReason || '시연 계정에서는 실제 결제나 취소를 진행할 수 없습니다.';
    const navigate = useNavigate();
    const location = useLocation();
    const recoveryView = isUnmePaymentRecovery(location.search);
    const dispatch = useDispatch();

    const [searchInput, setSearchInput] = useState(""); // 입력창 값
    const [search, setSearch] = useState(""); // 검색 버튼으로 적용된 값(필터에 사용)
    const [searchHighlighted, setSearchHighlighted] = useState(false);
    const searchHistoryRef = useRef([]); // 검색 버튼 기준 히스토리
    const [resultStatusFilter, setResultStatusFilter] = useState('');
  const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [page, setPage] = useState(1);
  const visiblePagesRef = useRef(1);
  visiblePagesRef.current = page;
    const [, setTotal] = useState(0);
    const [isExcelDownloading, setIsExcelDownloading] = useState(false);
    const [paymentSummary, setPaymentSummary] = useState({
        transactionCount: 0,
        approvalCount: 0,
        cancelCount: 0,
        failedCount: 0,
        approvalAmount: 0,
        cancelAmount: 0,
        netPaymentAmount: 0,
    });
    const [hasMore, setHasMore] = useState(false);
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [draftDateFrom, setDraftDateFrom] = useState("");
    const [draftDateTo, setDraftDateTo] = useState("");
    const [dateSheetOpen, setDateSheetOpen] = useState(false);
    const [periodSummaryExpanded, setPeriodSummaryExpanded] = useState(true);
    const scrollContainerRef = useRef(null);
    const loadMoreRef = useRef(null);
    const loadingMoreRef = useRef(false);
    const activeRequestRef = useRef(0);
    const [canceledIds, setCanceledIds] = useState([]);
    const [toast, setToast] = useState({ visible: false, message: "" });
    const [cancelModal, setCancelModal] = useState({ open: false, txId: null, paymentId: null });
    const [receiptModal, setReceiptModal] = useState({ open: false, emailInput: "", paymentTransactionId: null, isDemo: false });
    const [isSendingReceipt, setIsSendingReceipt] = useState(false);
    const [sendMethod, setSendMethod] = useState('email'); // 'email' | 'sms' | 'kakao'
    const [receiptPhone, setReceiptPhone] = useState('');
    const [receiptPreviewData, setReceiptPreviewData] = useState(null);
    const receiptInfoRequestRef = useRef(0);
    useEffect(() => () => { receiptInfoRequestRef.current += 1; }, []);
    const [receiptViewMode, setReceiptViewMode] = useState("approval");
    const [expandedPharmacies, setExpandedPharmacies] = useState(new Set());

    // 전표용 공급자/가맹점/PG가맹점 정보 (1회 조회)
    const [receiptSupplierInfo, setReceiptSupplierInfo] = useState(null);
    const [receiptMerchantInfo, setReceiptMerchantInfo] = useState(null);
    const [receiptPgMerchantRows, setReceiptPgMerchantRows] = useState([]);

    useEffect(() => {
        dispatch(change_Current_Location("거래조회"));
        dispatch(changeHeaderTitle({
            mainTitle: "거래내역",
            subTitle: ""
        }));
        // 전표 정보 1회 조회
        const baseUrl = process.env.REACT_APP_API || "";
        axios.get(baseUrl + "/api/terminal/receipt-info/supplier", { withCredentials: true })
            .then(({ data }) => {
                if (data?.code === 1000 && data?.data?.supplierInfo) {
                    setReceiptSupplierInfo(data.data.supplierInfo);
                }
            })
            .catch(() => {});
        axios.get(baseUrl + "/api/terminal/receipt-info/merchant", { withCredentials: true })
            .then(({ data }) => {
                if (data?.code === 1000 && data?.data?.merchantInfo) {
                    setReceiptMerchantInfo(data.data.merchantInfo);
                }
            })
            .catch(() => {});
        axios.get(baseUrl + "/api/terminal/receipt-info/pg-merchant", { withCredentials: true })
            .then(({ data }) => {
                if (data?.code === 1000 && data?.data?.rows) {
                    setReceiptPgMerchantRows(data.data.rows);
                }
            })
            .catch(() => {});
    }, [dispatch]);

    const fetchTransactions = useCallback(async (pageNumber = 1, append = false, quiet = false) => {
        if (append && loadingMoreRef.current) return;
        const requestId = ++activeRequestRef.current;
        if (append) {
            loadingMoreRef.current = true;
            setLoadingMore(true);
        } else if (!quiet) {
            setLoading(true);
        }
        const baseUrl = process.env.REACT_APP_API || "";
        try {
            if (demoMode) {
                const demoTransactions = createDemoTransactions({ search, dateFrom, dateTo });
                if (requestId !== activeRequestRef.current) return;
                setTransactions(demoTransactions);
                setPage(1);
                setTotal(demoTransactions.length);
                setPaymentSummary(summarizeDemoTransactions(demoTransactions));
                setHasMore(false);
                return;
            }
            // GET /api/terminal/payment/manual
            // Query: page, limit, status, dateFrom, dateTo, q(약국명 검색)
            // dateFrom / dateTo 는 YYYY-MM-DD 형식으로 전달
            const params = withUnmePaymentRecoveryParams({
                page: pageNumber,
                limit: PAYMENT_PAGE_SIZE,
            }, location.search);
            if (resultStatusFilter) params.status = resultStatusFilter;
      if (search.trim()) params.q = search.trim();
            if (dateFrom) params.dateFrom = dateFrom;
            if (dateTo) params.dateTo = dateTo;

            const { data } = await readPaymentList(baseUrl + "/api/terminal/payment/manual", {
                params,
                timeout: 10000,
          withCredentials: true,
            }, quiet ? visiblePagesRef.current : 1);

            if (requestId !== activeRequestRef.current) return;
            let rows = [];
            let responseTotal = 0;
            let responseHasMore = false;
            let nextSummary = {
                transactionCount: 0,
                approvalCount: 0,
                cancelCount: 0,
                failedCount: 0,
                approvalAmount: 0,
                cancelAmount: 0,
                netPaymentAmount: 0,
            };
            if (data?.code !== 1000) throw new Error("결과 조회 실패");
            if (data?.code === 1000) {
                if (Array.isArray(data?.data?.rows)) {
                    const responseData = data.data;
                    const apiSummary = responseData.summary || {};
                    rows = responseData.rows;
                    responseTotal = Number(
                        apiSummary.transactionCount ??
                        apiSummary.transaction_count ??
                        responseData.total ??
                        rows.length
                    );
                    nextSummary = {
                        transactionCount: responseTotal,
                        approvalCount: Number(apiSummary.approvalCount ?? apiSummary.approval_count ?? 0),
                        cancelCount: Number(apiSummary.cancelCount ?? apiSummary.cancel_count ?? 0),
                        failedCount: Number(apiSummary.failedCount ?? apiSummary.failed_count ?? 0),
                        approvalAmount: Number(apiSummary.approvalAmount ?? apiSummary.approval_amount ?? 0),
                        cancelAmount: Number(apiSummary.cancelAmount ?? apiSummary.cancel_amount ?? 0),
                        netPaymentAmount: Number(apiSummary.netPaymentAmount ?? apiSummary.net_payment_amount ?? 0),
                    };
                    const responseLimit = Number(responseData.limit ?? PAYMENT_PAGE_SIZE);
                    responseHasMore = responseData.hasNext !== undefined
                        ? Boolean(responseData.hasNext)
                        : pageNumber * responseLimit < responseTotal;
                } else if (Array.isArray(data?.data)) {
                    rows = data.data;
                    responseTotal = rows.length;
                    nextSummary.transactionCount = responseTotal;
                }
            }

            const mapped = Array.isArray(rows) ? rows.map(mapPaymentToTransaction) : [];
            if (append) {
                setTransactions((current) => mergeTransactions(current, mapped));
            } else {
                setTransactions(mapped);
            }
            setPage(quiet ? (data?.data?.refreshedPages || 1) : pageNumber);
            setTotal(responseTotal);
            setPaymentSummary(nextSummary);
            setHasMore(responseHasMore);
        } catch (err) {
            if (requestId !== activeRequestRef.current) return;
            if (!append && !quiet) {
                setTransactions([]);
                setPage(1);
                setTotal(0);
                setPaymentSummary({
                    transactionCount: 0,
                    approvalCount: 0,
                    cancelCount: 0,
                    failedCount: 0,
                    approvalAmount: 0,
                    cancelAmount: 0,
                    netPaymentAmount: 0,
                });
                setHasMore(false);
            }
        } finally {
            if (requestId === activeRequestRef.current) {
                setLoading(false);
                setLoadingMore(false);
                loadingMoreRef.current = false;
            }
        }
    }, [resultStatusFilter, search, dateFrom, dateTo, demoMode, location.search]);

    useEffect(() => {
        scrollContainerRef.current?.scrollTo({ top: 0 });
        setTransactions([]);
        setPage(1);
        setTotal(0);
        setPaymentSummary({
            transactionCount: 0,
            approvalCount: 0,
            cancelCount: 0,
            failedCount: 0,
            approvalAmount: 0,
            cancelAmount: 0,
            netPaymentAmount: 0,
        });
        setHasMore(false);
        fetchTransactions(1, false);
    }, [fetchTransactions]);

    useEffect(() => {
        const target = loadMoreRef.current;
        const root = scrollContainerRef.current;
        if (!target || !root || loading || loadingMore || !hasMore) return undefined;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !loadingMoreRef.current) {
                    fetchTransactions(page + 1, true);
                }
            },
            { root, rootMargin: "160px 0px", threshold: 0.01 }
        );
        observer.observe(target);
        return () => observer.disconnect();
    }, [fetchTransactions, hasMore, loading, loadingMore, page]);

    // 검색 적용 (검색 버튼 클릭 시에만 호출)
    const applySearch = (newApplied) => {
        if (newApplied === search) return;
        searchHistoryRef.current.push(search);
        setSearch(newApplied);
        setSearchInput(newApplied);
    };

    const dateFilterLabel = dateFrom && dateTo
        ? dateFrom === dateTo
            ? formatFilterDate(dateFrom)
            : `${formatFilterDate(dateFrom)} - ${formatFilterDate(dateTo)}`
        : dateFrom
            ? `${formatFilterDate(dateFrom)} 이후`
            : dateTo
                ? `${formatFilterDate(dateTo)} 이전`
                : "전체 기간";
    const hasDateFilter = Boolean(dateFrom || dateTo);
    const dateRangeInvalid = Boolean(
        draftDateFrom && draftDateTo && draftDateFrom > draftDateTo
    );
    const dateSelectionIncomplete = Boolean(
        (draftDateFrom && !draftDateTo) || (!draftDateFrom && draftDateTo)
    );
    const dateSelectionGuide = !draftDateFrom
        ? "먼저 시작일을 선택해 주세요."
        : !draftDateTo
            ? "이제 종료일을 선택해 주세요."
            : "선택한 기간을 확인한 후 적용해 주세요.";
    const today = getKstToday();
    const todayDate = dayjs(today);
    const datePresetOptions = [
        { key: "today", label: "오늘", from: today, to: today },
        {
            key: "yesterday",
            label: "어제",
            from: todayDate.subtract(1, "day").format("YYYY-MM-DD"),
            to: todayDate.subtract(1, "day").format("YYYY-MM-DD"),
        },
        {
            key: "week",
            label: "최근 7일",
            from: todayDate.subtract(6, "day").format("YYYY-MM-DD"),
            to: today,
        },
        {
            key: "month",
            label: "이번 달",
            from: todayDate.startOf("month").format("YYYY-MM-DD"),
            to: today,
        },
    ];

    const openDateSheet = () => {
        setDraftDateFrom(dateFrom);
        setDraftDateTo(dateTo);
        setDateSheetOpen(true);
    };

    const applyDatePreset = (preset) => {
        setDraftDateFrom(preset.from);
        setDraftDateTo(preset.to);
    };

    const handleCalendarRangeChange = ([start, end]) => {
        setDraftDateFrom(formatInputDate(start));
        setDraftDateTo(formatInputDate(end));
    };

    const applyDateFilter = () => {
        if (dateRangeInvalid || dateSelectionIncomplete) return;
        setDateFrom(draftDateFrom);
        setDateTo(draftDateTo);
        setDateSheetOpen(false);
    };

    const clearDateFilter = () => {
        setDraftDateFrom("");
        setDraftDateTo("");
        setDateFrom("");
        setDateTo("");
        setDateSheetOpen(false);
    };

    // API에서 q(약국명)로 필터링된 목록을 받아오므로 클라이언트 필터 없이 그대로 사용
    const filtered = transactions;

    // 년도/날짜 단위 그룹핑
    const groupedByYear = useMemo(() => {
        // 최신 거래가 위에 오도록 정렬
        const sorted = [...filtered].sort(
            (a, b) => dayjs(b.date).valueOf() - dayjs(a.date).valueOf()
        );

        const yearMap = new Map();

        sorted.forEach(tx => {
            const d = dayjs.utc(tx.date).add(9, "hour"); // KST
            const year = d.year();
            const month = d.month() + 1;
            const day = d.date();
            const dateKey = d.format("YYYY-MM-DD");
            const dateLabel = `${month}월 ${day}일`;

            if (!yearMap.has(year)) {
                yearMap.set(year, new Map());
            }
            const dateMap = yearMap.get(year);
            if (!dateMap.has(dateKey)) {
                dateMap.set(dateKey, { label: dateLabel, items: [] });
            }
            dateMap.get(dateKey).items.push(tx);
        });

        // Map → 배열 (년도/날짜 순서 유지: 최근 년도부터)
        return Array.from(yearMap.entries())
            .sort((a, b) => b[0] - a[0])
            .map(([year, dateMap]) => ({
                year,
                dates: Array.from(dateMap.entries())
                    .sort((a, b) => dayjs(b[0]).valueOf() - dayjs(a[0]).valueOf())
                    .map(([key, value]) => ({ key, ...value })),
            }));
    }, [filtered]);

    // 전표 전송 토스트
    const showToast = (message) => {
        setToast({ visible: true, message });
        // 일정 시간 후 자동 숨김
        setTimeout(() => {
            setToast((prev) => ({ ...prev, visible: false }));
        }, 2000);
    };

    const handleExcelDownload = async () => {
        if (isExcelDownloading) return;
        if (demoMode) {
            showToast("시연 결제내역은 엑셀로 다운로드할 수 없습니다.");
            return;
        }
        if (paymentSummary.transactionCount <= 0) {
            showToast("다운로드할 결제내역이 없습니다.");
            return;
        }

        const params = {};
        if (resultStatusFilter) params.status = resultStatusFilter;
    if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (search.trim()) params.q = search.trim();

        setIsExcelDownloading(true);
        try {
            await downloadBlob({
                url: "/api/terminal/payment/manual/export",
                params,
                fallbackFilename: `결제내역_${dateFrom || "전체"}_${dateTo || "전체"}.xlsx`,
            });
            showToast("엑셀 다운로드가 시작되었습니다.");
        } catch (error) {
            showToast(error?.message || "엑셀 다운로드에 실패했습니다.");
        } finally {
            setIsExcelDownloading(false);
        }
    };

    const handleOpenReceiptModal = async (tx) => {
        const requestId = ++receiptInfoRequestRef.current;
        const paymentTransactionId =
            tx?.paymentTransactionId ??
            tx?.paymentId ??
            tx?.id ??
            null;
        if (APP_RECEIPT_VIEW_MODE === 1) {
            const amount = Number(tx?.amount || 0);
            const taxableAmount = Math.round(amount / 1.1);
            const vatAmount = amount - taxableAmount;
            const taxFreeAmount = 0;
            const serviceAmount = 0;
            const cardNumberMasked = tx?.cardNoMasked || "****-****-****-****";
            const isCanceled = !!tx?.cancelStatus;
            const approvalDateTime = formatKST(tx?.date, "YYYY.MM.DD. HH:mm:ss");
            const cancelDateTime = tx?.canceledAt ? formatKST(tx?.canceledAt, "YYYY.MM.DD. HH:mm:ss") : null;

            const previewData = {
                paymentTransactionId,
                cardBrand: tx?.cardName || "-",
                cardNumberMasked,
                installmentMonth: tx?.type || "일시불",
                approvalNumber: tx?.approvalNo || "-",
                approvalDateTime,
                cancelDateTime,
                isCanceled,
                pharmacyName: tx?.pharmacy || "-",
                taxableAmount: taxableAmount.toLocaleString("ko-KR") + "원",
                vatAmount: vatAmount.toLocaleString("ko-KR") + "원",
                taxFreeAmount: taxFreeAmount.toLocaleString("ko-KR") + "원",
                serviceAmount: serviceAmount.toLocaleString("ko-KR") + "원",
                totalAmount: amount.toLocaleString("ko-KR") + "원",
                ...(receiptSupplierInfo ? {
                    supplierName: receiptSupplierInfo.name || APP_RECEIPT_SUPPLIER_MOCK.supplierName,
                    supplierOwnerName: receiptSupplierInfo.owner_name || APP_RECEIPT_SUPPLIER_MOCK.supplierOwnerName,
                    supplierBusinessNo: receiptSupplierInfo.business_no || APP_RECEIPT_SUPPLIER_MOCK.supplierBusinessNo,
                    supplierContact: receiptSupplierInfo.contact || APP_RECEIPT_SUPPLIER_MOCK.supplierContact,
                    supplierAddress: receiptSupplierInfo.address || APP_RECEIPT_SUPPLIER_MOCK.supplierAddress,
                } : APP_RECEIPT_SUPPLIER_MOCK),
                ...(receiptMerchantInfo ? {
                    merchantName: receiptMerchantInfo.name || APP_RECEIPT_MERCHANT_MOCK.merchantName,
                    merchantOwnerName: receiptMerchantInfo.boss_name || APP_RECEIPT_MERCHANT_MOCK.merchantOwnerName,
                    merchantBusinessNo: receiptMerchantInfo.business_no || APP_RECEIPT_MERCHANT_MOCK.merchantBusinessNo,
                    merchantContact: receiptMerchantInfo.phone || APP_RECEIPT_MERCHANT_MOCK.merchantContact,
                    merchantAddress: receiptMerchantInfo.address || APP_RECEIPT_MERCHANT_MOCK.merchantAddress,
                } : APP_RECEIPT_MERCHANT_MOCK),
                ...(() => {
                    const provider = String(tx?.pgProvider || '').toUpperCase();
                    const matched = receiptPgMerchantRows.find(
                        (row) => String(row?.pg_provider || '').toUpperCase() === provider,
                    );
                    if (matched) {
                        return {
                            cardMerchantName: matched.name || APP_RECEIPT_CARD_MERCHANT_MOCK.cardMerchantName,
                            cardMerchantOwnerName: matched.owner_name || APP_RECEIPT_CARD_MERCHANT_MOCK.cardMerchantOwnerName,
                            cardMerchantBusinessNo: matched.business_no || APP_RECEIPT_CARD_MERCHANT_MOCK.cardMerchantBusinessNo,
                            cardMerchantContact: matched.contact || matched.phone || APP_RECEIPT_CARD_MERCHANT_MOCK.cardMerchantContact,
                            cardMerchantAddress: matched.address || APP_RECEIPT_CARD_MERCHANT_MOCK.cardMerchantAddress,
                        };
                    }
                    return APP_RECEIPT_CARD_MERCHANT_MOCK;
                })(),
            };
            let resolved;
            try {
                resolved = await resolveUnmeReceiptInfo({ role: 'terminal', transactionId: tx?.receiptTransactionId, previewData, isDemo: tx?.isDemo === true || demoMode });
            } catch (error) {
                if (requestId === receiptInfoRequestRef.current) showToast(error.message);
                return;
            }
            if (requestId !== receiptInfoRequestRef.current) return;
            setReceiptPreviewData(resolved);
            setReceiptViewMode("approval");
        }
        setReceiptModal({ open: true, emailInput: "", paymentTransactionId, isDemo: tx?.isDemo === true });
        setSendMethod('email');
        setReceiptPhone('');
    };

    const handleConfirmSendReceipt = async () => {
        if (receiptModal.isDemo || demoMode) {
            showToast("시연 데이터는 전표를 전송할 수 없습니다.");
            return;
        }
        if (receiptModal.paymentTransactionId == null) {
            showToast("전표 ID가 없습니다. 다시 시도해주세요.");
            return;
        }

        const closeReceipt = () => {
            receiptInfoRequestRef.current += 1;
            setReceiptModal({ open: false, emailInput: "", paymentTransactionId: null, isDemo: false });
            setReceiptPreviewData(null);
            setReceiptViewMode("approval");
            setSendMethod('email');
            setReceiptPhone('');
        };

        const baseUrl = process.env.REACT_APP_API || "";

        if (sendMethod === 'email') {
            const email = (receiptModal.emailInput || "").trim();
            if (!email) {
                showToast("전송할 이메일을 입력해주세요.");
                return;
            }
            try {
                setIsSendingReceipt(true);
                const { data } = await axios.post(
                    baseUrl + "/api/terminal/payment/manual/receipt-email",
                    {
                        paymentTransactionId: receiptModal.paymentTransactionId,
                        payment_transaction_id: receiptModal.paymentTransactionId,
                        email,
                    },
                    { withCredentials: true }
                );
                if (data?.code === 1000) {
                    showToast(data?.msg || "메일로 전표를 전송했습니다.");
                    closeReceipt();
                } else {
                    showToast(receiptSendError(data, data?.msg || "전표 이메일 전송에 실패했습니다."));
                }
            } catch (err) {
                showToast(receiptSendError(err, err?.response?.data?.msg || "전표 이메일 전송 중 오류가 발생했습니다."));
            } finally {
                setIsSendingReceipt(false);
            }
        } else if (sendMethod === 'sms') {
            const phone = (receiptPhone || '').replace(/[^0-9]/g, '');
            if (!phone) {
                showToast("휴대폰 번호를 입력해주세요.");
                return;
            }
            try {
                setIsSendingReceipt(true);
                const { data } = await axios.post(
                    baseUrl + "/api/terminal/payment/manual/receipt-sms",
                    { paymentTransactionId: receiptModal.paymentTransactionId, phone },
                    { withCredentials: true }
                );
                if (data?.code === 1000) {
                    showToast(data?.msg || "전표 문자를 전송했습니다.");
                    closeReceipt();
                } else {
                    showToast(receiptSendError(data, "관리자에게 문의해주세요."));
                }
            } catch (err) {
                showToast(receiptSendError(err, "관리자에게 문의해주세요."));
            } finally {
                setIsSendingReceipt(false);
            }
        } else if (sendMethod === 'kakao') {
            const phone = (receiptPhone || '').replace(/[^0-9]/g, '');
            if (!phone) {
                showToast("휴대폰 번호를 입력해주세요.");
                return;
            }
            try {
                setIsSendingReceipt(true);
                const { data } = await axios.post(
                    baseUrl + "/api/terminal/payment/manual/receipt-alimtalk",
                    { paymentTransactionId: receiptModal.paymentTransactionId, phone },
                    { withCredentials: true }
                );
                if (data?.code === 1000) {
                    showToast(data?.msg || "전표 알림톡을 발송했습니다.");
                    closeReceipt();
                } else {
                    showToast(receiptSendError(data, data?.msg || "전표 알림톡 발송에 실패했습니다."));
                }
            } catch (err) {
                showToast(receiptSendError(err, err?.response?.data?.msg || "전표 알림톡 발송 중 오류가 발생했습니다."));
            } finally {
                setIsSendingReceipt(false);
            }
        }
    };

    const handleCloseReceiptModal = () => {
        if (isSendingReceipt) return;
        receiptInfoRequestRef.current += 1;
        setReceiptModal({ open: false, emailInput: "", paymentTransactionId: null, isDemo: false });
        setReceiptPreviewData(null);
        setReceiptViewMode("approval");
        setSendMethod('email');
        setReceiptPhone('');
    };

    const handleOpenCancelModal = (tx) => {
        if (cancelBlocked) {
            showToast(manualPaymentConfig.loading ? '결제 설정을 확인하고 있습니다.' : cancelBlockReason);
            return;
        }
        const txId = tx?.id ?? tx;
        // paymentTransactionId(원장 ID)를 우선적으로 사용
        const paymentTransactionId =
            tx?.paymentTransactionId ??
            tx?.paymentId ??
            tx?.id ??
            tx;
        setCancelModal({ open: true, txId, paymentId: paymentTransactionId });
    };

    const handleConfirmCancel = async () => {
        if (cancelModal.txId == null) return;
        if (cancelBlocked) {
            showToast(manualPaymentConfig.loading ? '결제 설정을 확인하고 있습니다.' : cancelBlockReason);
            return;
        }
        const { txId, paymentId } = cancelModal; // paymentId = paymentTransactionId

        setCancelModal({ open: false, txId: null, paymentId: null });

        const baseUrl = process.env.REACT_APP_API || "";
        try {
            // 영업자 수기결제 취소: POST /api/terminal/payment/manual/cancel
            const { data } = await axios.post(
                baseUrl + "/api/terminal/payment/manual/cancel",
                {
                    paymentTransactionId: paymentId,
                    reason: "사용자 요청",
                },
                { withCredentials: true }
            );

            if (isDemoPaymentBlocked(data)) {
                showToast(getDemoPaymentBlockMessage(data));
                return;
            }
            if (showUnknownPayment(data, 'terminal', true)) return;
      const status = data?.data?.status;
            const providerResult = data?.data?.provider_result || {};
            const success = providerResult?.success !== false && status === "COMPLETED";

            if (data?.code === 1000 && success) {
                showToast(data?.msg || "결제취소가 완료되었습니다.");
                // UI 상에서는 즉시 취소된 것처럼 표시
                setCanceledIds((prev) => (prev.includes(txId) ? prev : [...prev, txId]));
                fetchTransactions();
            } else {
                const msg =
                    data?.data?.outRsltMsg ??
                    data?.data?.provider_result?.outRsltMsg ??
                    data?.msg ??
                    "결제취소에 실패했습니다.";
                showToast(msg);
            }
        } catch (err) {
      if (showUnknownPayment(err?.response?.data, 'terminal', true)) return;
            if (isDemoPaymentBlocked(err)) {
                showToast(getDemoPaymentBlockMessage(err));
                return;
            }
            const msg =
                err?.response?.data?.msg ||
                "결제취소에 실패했습니다.";
            showToast(msg);
        }
    };

    const handleCloseCancelModal = () => {
        setCancelModal({ open: false, txId: null, paymentId: null });
    };

    // 약국 클릭 핸들러 (펼침/접힘 토글)
    const togglePharmacyExpansion = (pharmacyName) => {
        setExpandedPharmacies((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(pharmacyName)) {
                newSet.delete(pharmacyName);
            } else {
                newSet.add(pharmacyName);
            }
            return newSet;
        });
    };

    // 약국별 거래내역 그룹화 (최대 5개)
    const pharmacyTransactions = useMemo(() => {
        const pharmacyMap = new Map();
        filtered.forEach(tx => {
            if (!pharmacyMap.has(tx.pharmacy)) {
                pharmacyMap.set(tx.pharmacy, []);
            }
            pharmacyMap.get(tx.pharmacy).push(tx);
        });

        // 각 약국별로 최신순 정렬 후 최대 5개만 반환
        const result = new Map();
        pharmacyMap.forEach((transactions, pharmacy) => {
            const sorted = [...transactions].sort(
                (a, b) => dayjs(b.date).valueOf() - dayjs(a.date).valueOf()
            );
            result.set(pharmacy, sorted.slice(0, 5));
        });
        return result;
    }, [filtered]);

    const renderDateGroupSummary = (dateGroup) => {
        const useServerSummary =
            dateFrom && dateFrom === dateTo && dateGroup.key === dateFrom;
        if (!useServerSummary && (hasMore || loadingMore)) return null;

        const approvalCount = useServerSummary
            ? paymentSummary.approvalCount
            : dateGroup.items.filter((item) => !isUnknownPayment(item) && item.transactionType === "APPROVAL").length;
        const cancelCount = useServerSummary
            ? paymentSummary.cancelCount
            : dateGroup.items.filter((item) => !isUnknownPayment(item) && item.transactionType === "CANCEL").length;
        const amount = useServerSummary
            ? paymentSummary.netPaymentAmount
            : dateGroup.items.reduce((sum, item) => {
                const transactionStatus = String(item.transactionStatus || "").toUpperCase();
                if (isUnknownPayment(item) || transactionStatus === "FAILED") return sum;
                const itemAmount = Math.abs(Number(item.amount || 0));
                return item.transactionType === "CANCEL" ? sum - itemAmount : sum + itemAmount;
            }, 0);

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    gap: "1px",
                    color: "#667085",
                    fontSize: "12px",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                    lineHeight: 1.35,
                }}
            >
                <span>
                    승인 {approvalCount.toLocaleString("ko-KR")} · 취소 {cancelCount.toLocaleString("ko-KR")}
                </span>
                <span style={{ color: "#344054", fontWeight: 600 }}>
                    순결제 {amount.toLocaleString("ko-KR")}원
                </span>
            </div>
        );
    };

    return (
        <div
            style={{
                height: "100dvh",
                minHeight: 0,
                maxHeight: "100dvh",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                maxWidth: "768px",
                margin: "0 auto",
                background: "#FFFFFF",
                overflow: "hidden",
            }}
        >
            <style>
                {`
                    button, a, [onClick] {
                        outline: none !important;
                        -webkit-tap-highlight-color: transparent;
                        -webkit-touch-callout: none;
                        user-select: none;
                        transition: transform 0.1s ease, opacity 0.1s ease;
                    }
                    button:focus, a:focus, [onClick]:focus {
                        outline: none !important;
                    }
                    button:active, a:active, [onClick]:active {
                        outline: none !important;
                        transform: scale(0.96);
                        opacity: 0.8;
                    }
                    input:focus, select:focus, textarea:focus {
                        outline: none !important;
                        -webkit-tap-highlight-color: transparent;
                        border-color: #E5E7EB !important;
                        box-shadow: none !important;
                    }
                    input, select, textarea {
                        outline: none !important;
                    }
                    input:focus-visible {
                        outline: none !important;
                        border-color: #E5E7EB !important;
                        box-shadow: none !important;
                    }
                    .terminal-transaction-info:focus-visible {
                        box-shadow: inset 0 0 0 2px #98A2B3;
                        border-radius: 12px 12px 0 0;
                    }
                    .terminal-payment-date-picker {
                        width: 100%;
                        border: 0;
                        border-radius: 10px;
                        font-family: inherit;
                        font-size: 13px;
                    }
                    .terminal-payment-date-picker .react-datepicker__month-container {
                        width: 100%;
                        float: none;
                    }
                    .terminal-payment-date-picker .react-datepicker__header {
                        padding: 10px 0 6px;
                        border-bottom: 0;
                        background: #FFFFFF;
                    }
                    .terminal-payment-date-picker .react-datepicker__current-month {
                        color: #101828;
                        font-size: 14px;
                        font-weight: 700;
                    }
                    .terminal-payment-date-picker .react-datepicker__month {
                        margin: 0 6px 8px;
                    }
                    .terminal-payment-date-picker .react-datepicker__week,
                    .terminal-payment-date-picker .react-datepicker__day-names {
                        display: flex;
                    }
                    .terminal-payment-date-picker .react-datepicker__day-name,
                    .terminal-payment-date-picker .react-datepicker__day {
                        flex: 1 1 0;
                        width: auto;
                        min-width: 0;
                        margin: 1px;
                        line-height: 34px;
                        border-radius: 8px;
                    }
                    .terminal-payment-date-picker .react-datepicker__day-name {
                        color: #98A2B3;
                        font-size: 11px;
                        font-weight: 600;
                    }
                    .terminal-payment-date-picker .react-datepicker__day {
                        color: #344054;
                        font-weight: 500;
                    }
                    .terminal-payment-date-picker .react-datepicker__day:hover {
                        background: #F2F4F7;
                    }
                    .terminal-payment-date-picker .react-datepicker__day--in-range,
                    .terminal-payment-date-picker .react-datepicker__day--in-selecting-range {
                        border-radius: 6px;
                        background: rgba(var(--brand-primary-rgb), 0.12);
                        color: var(--brand-secondary);
                    }
                    .terminal-payment-date-picker .react-datepicker__day--range-start,
                    .terminal-payment-date-picker .react-datepicker__day--range-end,
                    .terminal-payment-date-picker .react-datepicker__day--selected {
                        background: var(--brand-secondary);
                        color: #FFFFFF;
                        font-weight: 700;
                    }
                    .terminal-payment-date-picker .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--selected):not(.react-datepicker__day--in-range) {
                        background: transparent;
                        color: #344054;
                    }
                    .terminal-payment-date-picker .react-datepicker__day--today:not(.react-datepicker__day--selected):not(.react-datepicker__day--in-range) {
                        background: #FFFFFF;
                        color: var(--brand-secondary);
                        box-shadow: inset 0 0 0 1px var(--brand-secondary);
                        font-weight: 700;
                    }
                    .terminal-payment-date-picker .react-datepicker__day--outside-month,
                    .terminal-payment-date-picker .react-datepicker__day--disabled {
                        color: #D0D5DD;
                    }
                    .terminal-payment-date-picker .react-datepicker__navigation {
                        top: 8px;
                    }
                `}
            </style>
            {/* 고정 헤더 영역 */}
            <div
                style={{
                    flexShrink: 0,
                    background: "#FFFFFF",
                    zIndex: 10,
                    position: "relative",
                }}
            >
                {/* 헤더 */}
                <div style={{
                    background: "linear-gradient(160deg, var(--brand-gradient-start) 0%, var(--brand-gradient-mid) 60%, var(--brand-gradient-end) 100%)",
                    height: "62px",
                    padding: "0 12px 0 10px",
                    color: "#FFFFFF",
                    display: "flex",
                    alignItems: "center",
                    boxSizing: "border-box"
                }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0 2px",
                        position: "relative",
                        width: "100%",
                    }}>
                        <button
                            onClick={() => {
                                if (searchHistoryRef.current.length > 0) {
                                    const prev = searchHistoryRef.current.pop();
                                    setSearch(prev);
                                    setSearchInput(prev);
                                } else {
                                    navigate("/app/dashboard");
                                }
                            }}
                            style={{
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                                padding: "2px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <ChevronLeft size={28} color="#FFFFFF" />
                        </button>
                        <h1 style={{
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            fontSize: "16px",
                            fontWeight: 700,
                            color: "#FFFFFF",
                            margin: 0,
                        }}>
                            결제내역
                        </h1>
                        <div style={{ width: "28px", height: "28px" }} />
                    </div>
                </div>

                <PaymentStatusFilter value={resultStatusFilter} onChange={setResultStatusFilter} />
      <PaymentResultMonitor rows={transactions} refresh={() => fetchTransactions(1, false, true)} />
                <DemoModeBanner />
                {recoveryView && <div role="status" style={{ margin: '8px 16px', padding: '12px', borderRadius: 8, background: '#fffbeb', color: '#78350f', fontSize: 13, lineHeight: 1.5 }}>결제 결과를 확인해 주세요. 실패로 표시되어도 다시 결제하지 말고 관리자에게 확인해 주세요.</div>}

                {/* 검색창 + 검색 버튼 */}
                <div
                    style={{
                        padding: "10px 14px",
                        flexShrink: 0,
                        borderBottom: "1px solid #EAECF0",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <div style={{ position: "relative", flex: 1, minWidth: 0 }}>
                            <Search
                                size={18}
                                style={{
                                    position: "absolute",
                                    left: "12px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: "#9CA3AF",
                                }}
                            />
                            <input
                                type="search"
                                aria-label="업체명 검색"
                                placeholder="업체명 검색"
                                value={searchInput}
                                onChange={(e) => {
                                    setSearchInput(e.target.value);
                                    setSearchHighlighted(false);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        applySearch(searchInput.trim());
                                    }
                                }}
                                style={{
                                    width: "100%",
                                    height: "42px",
                                    padding: "0 42px 0 38px",
                                    border: "1px solid " + (searchHighlighted ? "#3182F6" : "#E4E7EC"),
                                    borderRadius: "10px",
                                    boxSizing: "border-box",
                                    fontSize: "14px",
                                    background: searchHighlighted ? "#EFF6FF" : "#F9FAFB",
                                    outline: "none",
                                    transition: "all 0.3s ease",
                                    boxShadow: searchHighlighted ? "0 0 0 3px rgba(var(--brand-primary-rgb), 0.1)" : "none",
                                    animation: searchHighlighted ? "searchPulse 1.5s ease-in-out" : "none",
                                }}
                            />
                            {searchInput && (
                                <button
                                    type="button"
                                    aria-label="검색어 지우기"
                                    onClick={() => {
                                        setSearchInput("");
                                        if (search !== "") {
                                            searchHistoryRef.current.push(search);
                                            setSearch("");
                                        }
                                    }}
                                    style={{
                                        position: "absolute",
                                        right: 0,
                                        top: 0,
                                        width: "42px",
                                        height: "42px",
                                        padding: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "transparent",
                                        border: "none",
                                        cursor: "pointer",
                                    }}
                                >
                                    <X size={16} color="#6B7280" />
                                </button>
                            )}
                        </div>
                        <button
                            type="button"
                            onClick={() => applySearch(searchInput.trim())}
                            aria-label="업체명 검색"
                            style={{
                                flexShrink: 0,
                                width: "54px",
                                height: "42px",
                                padding: 0,
                                borderRadius: "10px",
                                border: "none",
                                background: "#F2F4F7",
                                color: "#344054",
                                fontSize: "13px",
                                fontWeight: 600,
                                cursor: "pointer",
                            }}
                        >
                            검색
                        </button>
                        <button
                            type="button"
                            onClick={openDateSheet}
                            aria-label={`날짜 검색: ${dateFilterLabel}`}
                            aria-pressed={hasDateFilter}
                            style={{
                                width: "42px",
                                height: "42px",
                                padding: 0,
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                                borderRadius: "10px",
                                border: "none",
                                background: hasDateFilter ? "#EFF6FF" : "#F7F8FA",
                                color: hasDateFilter ? "var(--brand-secondary)" : "#344054",
                                cursor: "pointer",
                            }}
                        >
                            <CalendarDays size={18} strokeWidth={2} />
                        </button>
                    </div>
                    {hasDateFilter && (
                        <div
                            style={{
                                width: "fit-content",
                                maxWidth: "100%",
                                height: "32px",
                                marginTop: "8px",
                                display: "flex",
                                alignItems: "center",
                                borderRadius: "8px",
                                background: "#EFF6FF",
                                color: "var(--brand-secondary)",
                                overflow: "hidden",
                            }}
                        >
                            <button
                                type="button"
                                onClick={openDateSheet}
                                aria-label={`선택 기간 변경: ${dateFilterLabel}`}
                                style={{
                                    minWidth: 0,
                                    height: "32px",
                                    padding: "0 4px 0 10px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    border: "none",
                                    background: "transparent",
                                    color: "inherit",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                }}
                            >
                                <CalendarDays size={14} strokeWidth={2} />
                                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {dateFilterLabel}
                                </span>
                            </button>
                            <button
                                type="button"
                                onClick={clearDateFilter}
                                aria-label="날짜 검색 초기화"
                                title="날짜 검색 초기화"
                                style={{
                                    width: "32px",
                                    height: "32px",
                                    padding: 0,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                    border: "none",
                                    background: "transparent",
                                    color: "inherit",
                                    cursor: "pointer",
                                }}
                            >
                                <X size={14} />
                            </button>
                        </div>
                    )}
                    {hasDateFilter && !loading && (
                        <div
                            style={{
                                marginTop: "10px",
                                border: "1px solid #E4E7EC",
                                borderRadius: "10px",
                                background: "#FFFFFF",
                                overflow: "hidden",
                            }}
                        >
                            <button
                                type="button"
                                aria-expanded={periodSummaryExpanded}
                                aria-controls="terminal-payment-period-summary"
                                onClick={() => setPeriodSummaryExpanded((current) => !current)}
                                style={{
                                    width: "100%",
                                    minHeight: "42px",
                                    padding: "9px 12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                    border: "none",
                                    background: "transparent",
                                    color: "#101828",
                                    cursor: "pointer",
                                }}
                            >
                                <span style={{ fontSize: "13px", fontWeight: 700, flexShrink: 0 }}>
                                    기간 총계
                                </span>
                                <span
                                    style={{
                                        minWidth: 0,
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "flex-end",
                                        gap: "5px",
                                        fontSize: "14px",
                                        fontWeight: 700,
                                    }}
                                >
                                    <span style={{ color: "#475467", fontSize: "12px", fontWeight: 600 }}>
                                        순 결제
                                    </span>
                                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                        {Number(paymentSummary.netPaymentAmount || 0).toLocaleString("ko-KR")}원
                                    </span>
                                    <ChevronDown
                                        size={16}
                                        strokeWidth={2}
                                        aria-hidden="true"
                                        style={{
                                            flexShrink: 0,
                                            color: "#667085",
                                            transform: periodSummaryExpanded ? "rotate(180deg)" : "rotate(0deg)",
                                            transition: "transform 0.2s ease",
                                        }}
                                    />
                                </span>
                            </button>
                            {periodSummaryExpanded && (
                                <div
                                    id="terminal-payment-period-summary"
                                    style={{
                                        minHeight: "42px",
                                        padding: "9px 12px",
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1fr",
                                        alignItems: "center",
                                        borderTop: "1px solid #D1FADF",
                                        background: "#F6FEF9",
                                        fontSize: "12px",
                                        lineHeight: 1.45,
                                    }}
                                >
                                    <div style={{ paddingRight: "10px", borderRight: "1px solid #D1E9D8" }}>
                                        <span style={{ color: "#067647", fontWeight: 700 }}>
                                            승인 {Number(paymentSummary.approvalCount || 0).toLocaleString("ko-KR")}건
                                        </span>
                                        <div style={{ marginTop: "1px", color: "#344054", fontWeight: 600 }}>
                                            {Number(paymentSummary.approvalAmount || 0).toLocaleString("ko-KR")}원
                                        </div>
                                    </div>
                                    <div style={{ paddingLeft: "10px" }}>
                                        <span style={{ color: "#D92D20", fontWeight: 700 }}>
                                            취소 {Number(paymentSummary.cancelCount || 0).toLocaleString("ko-KR")}건
                                        </span>
                                        <div style={{ marginTop: "1px", color: "#344054", fontWeight: 600 }}>
                                            {Number(paymentSummary.cancelAmount || 0).toLocaleString("ko-KR")}원
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {manualPaymentConfig.paymentEnabled === false && (
                <div role="status" style={{ flexShrink: 0, margin: "10px 14px 0", padding: "9px 12px", borderRadius: 10, background: "#f5f3ff", color: "#6d28d9", fontSize: 12, fontWeight: 700, lineHeight: 1.4 }}>
                    {cancelBlockReason}
                </div>
            )}
            {/* 스크롤 가능한 리스트 영역 - 상단 패딩 없음(스티키 날짜가 top에 꽉 붙도록) */}
            <div
                ref={scrollContainerRef}
                style={{
                    flex: 1,
                    overflowY: "auto",
                    overflowX: "hidden",
                    minHeight: 0,
                    WebkitOverflowScrolling: "touch",
                    touchAction: "pan-y",
                    overscrollBehaviorY: "contain",
                    padding: "0 14px 20px",
                    background: "#F7F8FA",
                }}
            >
                {loading ? (
                    <div style={{ textAlign: "center", marginTop: "40px", color: "#9CA3AF", fontSize: "14px" }}>
                        로딩 중...
                    </div>
                ) : groupedByYear.length === 0 ? (
                    <div
                        style={{
                            textAlign: "center",
                            marginTop: "40px",
                            color: "#9CA3AF",
                            fontSize: "14px",
                        }}
                    >
                        {search || hasDateFilter ? "검색 결과가 없습니다." : "결제내역이 없습니다."}
                    </div>
                ) : (
                    <div style={{ paddingTop: "4px" }}>
                    {groupedByYear.map((yearGroup) => (
                        <div key={yearGroup.year} style={{ marginBottom: "16px" }}>
                            {/* 년도 */}
                            {yearGroup.year !== dayjs.utc().add(9, "hour").year() && (
                                <div
                                    style={{
                                        padding: "8px 4px 2px",
                                        fontSize: "15px",
                                        fontWeight: 700,
                                        color: "#667085",
                                    }}
                                >
                                    {yearGroup.year}년
                                </div>
                            )}

                            {/* 날짜별 그룹 - 날짜 헤더 스티키(해당 날짜 구간 스크롤 시 상단 고정) */}
                            {yearGroup.dates.map((dateGroup) => (
                                <div key={dateGroup.key} style={{ marginBottom: "16px" }}>
                                    {/* 스티키 날짜 헤더: 이 날짜 내역이 스크롤되는 동안 상단에 고정, 다음 날짜 나오면 위로 밀림 */}
                                    <div
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            zIndex: 10,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            gap: "12px",
                                            background: "rgba(247, 248, 250, 0.9)",
                                            backdropFilter: "blur(10px)",
                                            WebkitBackdropFilter: "blur(10px)",
                                            minHeight: "44px",
                                            padding: "14px 2px 8px",
                                            marginBottom: "6px",
                                            boxSizing: "border-box",
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontSize: "16px",
                                                fontWeight: 700,
                                                color: "#111827",
                                                lineHeight: 1.4,
                                            }}
                                        >
                                            {dateGroup.label}
                                        </div>
                                        {renderDateGroupSummary(dateGroup)}
                                    </div>

                                    {/* 거래내역 리스트 (날짜 컬럼 맞춤으로 spacer) */}
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                            gap: "4px",
                                        }}
                                    >
                                        <div style={{ display: "none" }} />
                                            <div
                                                style={{
                                                    flex: 1,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "8px",
                                                    minWidth: 0,
                                                }}
                                            >
                                            {dateGroup.items.map((tx) => {
                                                const time = formatKST(tx.date, "HH:mm");
                                                const finalStatus = String(tx.status || "").toUpperCase();
                                                const locallyCanceled = canceledIds.includes(tx.id);
                                                const isCancelTransaction = tx.transactionType === "CANCEL";
                                                const canCancel =
                                                    tx.transactionType === "APPROVAL" &&
                                                    finalStatus === "COMPLETED" &&
                                                    !locallyCanceled;
                                                const isCanceledApproval =
                                                    tx.transactionType === "APPROVAL" &&
                                                    (finalStatus === "CANCELED" || locallyCanceled);
                                                const transactionStatus = String(tx.transactionStatus || "").toUpperCase();
                                                const displayedAmount = isCancelTransaction
                                                    ? -Math.abs(Number(tx.amount || 0))
                                                    : Number(tx.amount || 0);
                                                const displayStatusLabel = isUnknownPayment(tx) ? unknownPaymentLabel(tx) : isCancelTransaction
                                                    ? "취소"
                                                    : isCanceledApproval
                                                        ? "취소된 결제"
                                                        : getStatusLabel(tx);
                                                const statusColor = isUnknownPayment(tx) ? "#b45309" :
                                                    isCancelTransaction
                                                        ? "#E5484D"
                                                        : isCanceledApproval
                                                            ? "#98A2B3"
                                                            : transactionStatus === "FAILED"
                                                            ? "#E5484D"
                                                            : transactionStatus === "REQUESTED" || transactionStatus === "APPROVED"
                                                                ? "#F79009"
                                                                : "#12B76A";
                                                const statusBackground = isUnknownPayment(tx) ? "#fffbeb" : isCancelTransaction
                                                    ? "#FFF1F1"
                                                    : isCanceledApproval
                                                        ? "#F2F4F7"
                                                        : transactionStatus === "FAILED"
                                                            ? "#FFF1F1"
                                                            : transactionStatus === "REQUESTED" || transactionStatus === "APPROVED"
                                                                ? "#FFF7E8"
                                                                : "#ECFDF3";
                                                const meta = [
                                                    time,
                                                    tx.cardName && tx.cardName !== "-" ? tx.cardName : null,
                                                    tx.approvalNo || null,
                                                ].filter(Boolean).join(" · ");

                                                return (
                                                    <div
                                                        key={tx.id}
                                                        style={{
                                                            overflow: "hidden",
                                                            backgroundColor: "#FFFFFF",
                                                            border: "1px solid #EAECF0",
                                                            borderLeft: isCancelTransaction
                                                                ? "3px solid #FDA29B"
                                                                : isCanceledApproval
                                                                    ? "3px solid #D0D5DD"
                                                                    : "1px solid #EAECF0",
                                                            borderRadius: "10px",
                                                            boxShadow: "0 1px 2px rgba(16, 24, 40, 0.03)",
                                                        }}
                                                    >
                                                        {/* 정보 블록 */}
                                                        <div
                                                            className="terminal-transaction-info"
                                                            role="button"
                                                            tabIndex={0}
                                                            aria-label={`${tx.pharmacy} 거래 보기`}
                                                            onClick={() => handleOpenReceiptModal(tx)}
                                                            onKeyDown={(event) => {
                                                                if (event.key === "Enter" || event.key === " ") {
                                                                    event.preventDefault();
                                                                    event.currentTarget.click();
                                                                }
                                                            }}
                                                            style={{
                                                                padding: "13px 14px 10px",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    gap: "12px",
                                                                }}
                                                            >
                                                                <div style={{ minWidth: 0, display: "flex", alignItems: "center", gap: "6px" }}>
                                                                    <span
                                                                        style={{
                                                                            minWidth: 0,
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            whiteSpace: "nowrap",
                                                                            color: "#1A1D23",
                                                                            fontSize: "16px",
                                                                            fontWeight: 600,
                                                                            letterSpacing: 0,
                                                                        }}
                                                                    >
                                                                        {tx.pharmacy}
                                                                    </span>
                                                                    {tx.isDemo && (
                                                                        <span className="shrink-0 rounded-full bg-violet-50 px-1.5 py-0.5 text-[10px] font-bold text-violet-700">
                                                                            시연 데이터
                                                                        </span>
                                                                    )}
                                                                </div>
                                                                <span
                                                                    style={{
                                                                        flexShrink: 0,
                                                                        color: isCancelTransaction
                                                                            ? "#E5484D"
                                                                            : isCanceledApproval
                                                                                ? "#98A2B3"
                                                                                : "#1A1D23",
                                                                        fontSize: "17px",
                                                                        fontWeight: 700,
                                                                        letterSpacing: 0,
                                                                        textDecoration: isCanceledApproval ? "line-through" : "none",
                                                                        textDecorationThickness: isCanceledApproval ? "1px" : undefined,
                                                                    }}
                                                                >
                                                                    {displayedAmount.toLocaleString("ko-KR")}원
                                                                </span>
                                                            </div>
                                                            <div
                                                                style={{
                                                                    marginTop: "6px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    gap: "8px",
                                                                    color: "#8A8F98",
                                                                    fontSize: "12px",
                                                                    lineHeight: 1.4,
                                                                    letterSpacing: 0,
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        minWidth: 0,
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                    }}
                                                                >
                                                                    {meta}
                                                                </span>
                                                                <span
                                                                    role="status"
                                                                    aria-label={`상태: ${displayStatusLabel}`}
                                                                    style={{
                                                                        display: "inline-flex",
                                                                        alignItems: "center",
                                                                        gap: "4px",
                                                                        flexShrink: 0,
                                                                        color: statusColor,
                                                                        fontSize: "12px",
                                                                        fontWeight: 600,
                                                                        lineHeight: 1.4,
                                                                        padding: "2px 7px",
                                                                        borderRadius: "999px",
                                                                        background: statusBackground,
                                                                    }}
                                                                >
                                                                    {displayStatusLabel}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {isUnknownPayment(tx) && <p className="px-3 pb-3 text-xs text-amber-800">{safePaymentResultMessage(tx)}{tx.retryRecommended === false ? ' 재시도는 권장하지 않습니다.' : ''}</p>}
                                                        {/* 액션 블록 */}
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                height: "40px",
                                                                borderTop: "1px solid #F2F4F7",
                                                                boxSizing: "border-box",
                                                            }}
                                                        >
                                                            <button
                                                                type="button"
                                                                onClick={(event) => {
                                                                    event.stopPropagation();
                                                                    handleOpenReceiptModal(tx);
                                                                }}
                                                                aria-label="전표 보기 및 전송"
                                                                style={{
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "6px",
                                                                    flex: 1,
                                                                    minWidth: "44px",
                                                                    height: "40px",
                                                                    padding: "0 12px",
                                                                    background: "transparent",
                                                                    border: "none",
                                                                    borderRight: canCancel ? "1px solid #F2F4F7" : "none",
                                                                    borderRadius: 0,
                                                                    color: "#344054",
                                                                    cursor: "pointer",
                                                                    fontSize: "13px",
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                <ReceiptText size={16} strokeWidth={2} />
                                                                전표 보기
                                                            </button>
                                                            {canCancel && (
                                                                <button
                                                                    type="button"
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                        handleOpenCancelModal(tx);
                                                                    }}
                                                                    disabled={cancelBlocked}
                                                                    title={cancelBlocked ? (manualPaymentConfig.loading ? "결제 설정을 확인하고 있습니다." : cancelBlockReason) : "결제취소"}
                                                                    aria-label="결제취소"
                                                                    style={{
                                                                        width: "96px",
                                                                        minWidth: "96px",
                                                                        height: "40px",
                                                                        padding: 0,
                                                                        background: "transparent",
                                                                        border: "none",
                                                                        color: "#E5484D",
                                                                        cursor: cancelBlocked ? "not-allowed" : "pointer",
                                                                        opacity: cancelBlocked ? 0.45 : 1,
                                                                        fontSize: "13px",
                                                                        fontWeight: 600,
                                                                    }}
                                                                >
                                                                    {cancelBlocked ? "취소 불가" : "결제취소"}
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                    <div
                        ref={loadMoreRef}
                        aria-hidden={!loadingMore}
                        style={{
                            minHeight: hasMore ? "32px" : "1px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#8A8F98",
                            fontSize: "12px",
                        }}
                    >
                        {loadingMore ? "불러오는 중..." : null}
                    </div>
                    </div>
                )}
            </div>

            {/* 애니메이션 스타일 */}
            <style>
                {`
                    @keyframes slideDown {
                        from {
                            opacity: 0;
                            max-height: 0;
                            transform: translateY(-10px);
                        }
                        to {
                            opacity: 1;
                            max-height: 500px;
                            transform: translateY(0);
                        }
                    }
                    @keyframes searchPulse {
                        0%, 100% {
                            box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb), 0.1);
                        }
                        50% {
                            box-shadow: 0 0 0 6px rgba(var(--brand-primary-rgb), 0.15);
                        }
                    }
                `}
            </style>

            {/* 토스트 알람 애니메이션 스타일 */}
            <style>
                {`
                    @keyframes slideDownToast {
                        from {
                            opacity: 0;
                            transform: translateX(-50%) translateY(-100%);
                        }
                        to {
                            opacity: 1;
                            transform: translateX(-50%) translateY(0);
                        }
                    }
                `}
            </style>

            {/* 전표 전송 토스트 */}
            {toast.visible && (
                <div
                    style={{
                        position: "fixed",
                        top: "10px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "100%",
                        maxWidth: "768px",
                        padding: "0 16px",
                        boxSizing: "border-box",
                        zIndex: 3000,
                        display: "flex",
                        justifyContent: "center",
                        animation: "slideDownToast 0.3s ease-out",
                        pointerEvents: "none", // 클릭 이벤트를 통과시켜 뒤로가기 버튼 클릭 가능하게
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            padding: "12px 16px",
                            borderRadius: "12px",
                            backgroundColor: "#FFFFFF",
                            color: "#111827",
                            fontSize: "14px",
                            fontWeight: 500,
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                            pointerEvents: "auto", // 토스트 메시지 자체는 클릭 가능하게
                        }}
                    >
                        {/* 파란색 원형 아이콘 배경에 흰색 체크마크 */}
                        <div
                            style={{
                                width: "24px",
                                height: "24px",
                                borderRadius: "50%",
                                backgroundColor: "#3182F6",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                            }}
                        >
                            <Check size={14} color="#FFFFFF" />
                        </div>
                        <span>{toast.message}</span>
                    </div>
                </div>
            )}

            {dateSheetOpen && (
                <div
                    role="presentation"
                    onClick={() => setDateSheetOpen(false)}
                    style={{
                        position: "fixed",
                        inset: 0,
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "100%",
                        maxWidth: "768px",
                        height: "100dvh",
                        display: "flex",
                        alignItems: "flex-end",
                        background: "rgba(15, 23, 42, 0.45)",
                        zIndex: 1200,
                    }}
                >
                    <div
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="date-filter-title"
                        onClick={(event) => event.stopPropagation()}
                        style={{
                            width: "100%",
                            padding: "0 16px calc(16px + env(safe-area-inset-bottom))",
                            maxHeight: "92dvh",
                            overflowY: "auto",
                            boxSizing: "border-box",
                            borderRadius: "16px 16px 0 0",
                            background: "#FFFFFF",
                            boxShadow: "0 -10px 30px rgba(15, 23, 42, 0.16)",
                        }}
                    >
                        <div
                            style={{
                                height: "56px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                borderBottom: "1px solid #EAECF0",
                            }}
                        >
                            <h2
                                id="date-filter-title"
                                style={{
                                    margin: 0,
                                    color: "#101828",
                                    fontSize: "17px",
                                    fontWeight: 700,
                                }}
                            >
                                기간 선택
                            </h2>
                            <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                <button
                                    type="button"
                                    onClick={handleExcelDownload}
                                    disabled={isExcelDownloading}
                                    aria-busy={isExcelDownloading}
                                    aria-label={isExcelDownloading ? "엑셀 다운로드 중" : "현재 조회 결과 엑셀 다운로드"}
                                    title={isExcelDownloading ? "다운로드 중..." : "현재 조회 결과 엑셀 다운로드"}
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        padding: 0,
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "none",
                                        borderRadius: "10px",
                                        background: "#F2F4F7",
                                        color: "#344054",
                                        cursor: isExcelDownloading ? "not-allowed" : "pointer",
                                        opacity: isExcelDownloading ? 0.7 : 1,
                                    }}
                                >
                                    <Download size={18} />
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setDateSheetOpen(false)}
                                    aria-label="기간 선택 닫기"
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        padding: 0,
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "none",
                                        background: "transparent",
                                        color: "#667085",
                                        cursor: "pointer",
                                    }}
                                >
                                    <X size={20} />
                                </button>
                            </div>
                        </div>

                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                                gap: "6px",
                                padding: "16px 0",
                            }}
                        >
                            {datePresetOptions.map((preset) => {
                                const selected =
                                    draftDateFrom === preset.from && draftDateTo === preset.to;
                                return (
                                    <button
                                        key={preset.key}
                                        type="button"
                                        onClick={() => applyDatePreset(preset)}
                                        aria-pressed={selected}
                                        style={{
                                            height: "38px",
                                            padding: "0 4px",
                                            borderRadius: "8px",
                                            border: selected ? "1px solid #3182F6" : "1px solid #D0D5DD",
                                            background: selected ? "#EFF6FF" : "#FFFFFF",
                                            color: selected ? "var(--brand-secondary)" : "#344054",
                                            fontSize: "13px",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {preset.label}
                                    </button>
                                );
                            })}
                        </div>

                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "8px",
                                marginBottom: "10px",
                            }}
                        >
                            <div
                                style={{
                                    minWidth: 0,
                                    padding: "8px 10px",
                                    borderRadius: "8px",
                                    border: !draftDateFrom ? "1px solid var(--brand-secondary)" : "1px solid transparent",
                                    background: !draftDateFrom ? "#EFF6FF" : "#F9FAFB",
                                    boxSizing: "border-box",
                                }}
                            >
                                <div style={{ color: "#98A2B3", fontSize: "10px", fontWeight: 600 }}>시작일</div>
                                <div style={{ marginTop: "2px", color: "#344054", fontSize: "13px", fontWeight: 700 }}>
                                    {draftDateFrom ? dayjs(draftDateFrom).format("YYYY.MM.DD") : "날짜 선택"}
                                </div>
                            </div>
                            <div
                                style={{
                                    minWidth: 0,
                                    padding: "8px 10px",
                                    borderRadius: "8px",
                                    border: draftDateFrom && !draftDateTo ? "1px solid var(--brand-secondary)" : "1px solid transparent",
                                    background: draftDateFrom && !draftDateTo ? "#EFF6FF" : "#F9FAFB",
                                    boxSizing: "border-box",
                                }}
                            >
                                <div style={{ color: "#98A2B3", fontSize: "10px", fontWeight: 600 }}>종료일</div>
                                <div style={{ marginTop: "2px", color: draftDateTo ? "#344054" : "#98A2B3", fontSize: "13px", fontWeight: 700 }}>
                                    {draftDateTo ? dayjs(draftDateTo).format("YYYY.MM.DD") : "날짜 선택"}
                                </div>
                            </div>
                        </div>
                        <div
                            role="status"
                            aria-live="polite"
                            style={{
                                minHeight: "28px",
                                padding: "0 2px 8px",
                                boxSizing: "border-box",
                                color: "var(--brand-secondary)",
                                fontSize: "12px",
                                fontWeight: 700,
                            }}
                        >
                            {dateSelectionGuide}
                        </div>
                        <div style={{ border: "1px solid #EAECF0", borderRadius: "10px", overflow: "hidden" }}>
                            <DatePicker
                                selected={parseInputDate(draftDateFrom)}
                                onChange={handleCalendarRangeChange}
                                startDate={parseInputDate(draftDateFrom)}
                                endDate={parseInputDate(draftDateTo)}
                                maxDate={parseInputDate(today)}
                                openToDate={parseInputDate(draftDateFrom) || parseInputDate(today)}
                                selectsRange
                                inline
                                fixedHeight
                                locale={ko}
                                calendarStartDay={0}
                                calendarClassName="terminal-payment-date-picker"
                            />
                        </div>
                        <div style={{ display: "flex", gap: "8px", marginTop: "12px" }}>
                            <button
                                type="button"
                                onClick={() => {
                                    setDraftDateFrom("");
                                    setDraftDateTo("");
                                }}
                                style={{
                                    width: "96px",
                                    height: "46px",
                                    borderRadius: "8px",
                                    border: "1px solid #D0D5DD",
                                    background: "#FFFFFF",
                                    color: "#344054",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                }}
                            >
                                초기화
                            </button>
                            <button
                                type="button"
                                onClick={applyDateFilter}
                                disabled={dateRangeInvalid || dateSelectionIncomplete}
                                style={{
                                    flex: 1,
                                    height: "46px",
                                    borderRadius: "8px",
                                    border: "none",
                                    background: dateRangeInvalid || dateSelectionIncomplete ? "#D0D5DD" : "var(--brand-secondary)",
                                    color: "#FFFFFF",
                                    fontSize: "14px",
                                    fontWeight: 700,
                                    cursor: dateRangeInvalid || dateSelectionIncomplete ? "default" : "pointer",
                                }}
                            >
                                적용
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {receiptModal.open && receiptPreviewData && RECEIPT_UI_VERSION === 2 && (
                <ReceiptPreviewModalV2
                    data={receiptPreviewData}
                    viewMode={receiptViewMode}
                    onViewModeChange={setReceiptViewMode}
                    sendMethod={sendMethod}
                    onSendMethodChange={setSendMethod}
                    email={receiptModal.emailInput}
                    onEmailChange={(value) => setReceiptModal((prev) => ({ ...prev, emailInput: value }))}
                    phone={receiptPhone}
                    onPhoneChange={setReceiptPhone}
                    onSend={handleConfirmSendReceipt}
                    onClose={handleCloseReceiptModal}
                    isSending={isSendingReceipt}
                    smsEnabled={RECEIPT_SMS_ENABLED}
                    kakaoEnabled={RECEIPT_KAKAO_ENABLED}
                    transmissionDisabled={receiptModal.isDemo}
                    transmissionDisabledMessage="시연 데이터는 서버 원장이 없어 전표를 전송할 수 없습니다."
                />
            )}
            {/* 전표 모달 (UI 1) */}
            {receiptModal.open && RECEIPT_UI_VERSION !== 2 && (
                APP_RECEIPT_VIEW_MODE === 1 && receiptPreviewData ? (
                    <div style={{ position: "fixed", top: 0, left: "50%", transform: "translateX(-50%)", width: "100%", maxWidth: "768px", height: "100dvh", backgroundColor: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, overflowY: "auto", padding: "24px 0" }} onClick={handleCloseReceiptModal}>
                        <div style={{ backgroundColor: "#fff", borderRadius: "8px", border: "1px solid #e0e0e0", width: "330px", boxShadow: "0 10px 25px rgba(15,23,42,0.2)", display: "flex", flexDirection: "column", maxHeight: "80vh" }} onClick={(e) => e.stopPropagation()}>
                            <div style={{ position: "sticky", top: 0, zIndex: 10, padding: "16px 20px", background: "#fff", borderBottom: "1px solid #333", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px" }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontSize: "18px", fontWeight: 700, color: "#111", lineHeight: 1.2 }}>{RECEIPT_LABELS.titleKo}</div>
                                    <div style={{ marginTop: "2px", fontSize: "11px", fontWeight: 600, color: "#767676", lineHeight: 1.2 }}>{RECEIPT_LABELS.titleEn}</div>
                                </div>
                                {receiptPreviewData.isCanceled && (
                                    <div style={{ display: "flex", border: "1px solid #e5e7eb", borderRadius: "8px", overflow: "hidden" }}>
                                        <button type="button" onClick={() => setReceiptViewMode("approval")} style={{ padding: "6px 12px", fontSize: "13px", fontWeight: 600, border: "none", background: receiptViewMode === "approval" ? "var(--brand-primary)" : "#fff", color: receiptViewMode === "approval" ? "#fff" : "var(--brand-primary)", cursor: "pointer" }}>승인</button>
                                        <button type="button" onClick={() => setReceiptViewMode("cancel")} style={{ padding: "6px 12px", fontSize: "13px", fontWeight: 600, border: "none", background: receiptViewMode === "cancel" ? "#b91c1c" : "#fff", color: receiptViewMode === "cancel" ? "#fff" : "#b91c1c", cursor: "pointer" }}>취소</button>
                                    </div>
                                )}
                            </div>
                            <div style={{ overflowY: "auto", flex: 1, padding: "20px" }}>
                                <div style={{ fontSize: "16px", fontWeight: 700, paddingBottom: "12px" }}>거래정보</div>
                                <div style={{ fontSize: "14px" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>카드종류</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.cardBrand}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>카드번호</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.cardNumberMasked}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>할부</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.installmentMonth}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>거래유형</span><span style={{ fontWeight: 500 }}>{receiptViewMode === "approval" ? "승인" : "취소"}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>승인번호</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.approvalNumber}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>{receiptViewMode === "approval" ? "거래일시" : "취소일시"}</span><span style={{ fontWeight: 500 }}>{receiptViewMode === "approval" ? receiptPreviewData.approvalDateTime : (receiptPreviewData.cancelDateTime ?? "-")}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>거래처명</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.pharmacyName}</span></div>
                                </div>
                                <div style={{ borderBottom: "1px solid #e0e0e0", margin: "14px 0" }} />
                                <div style={{ fontSize: "16px", fontWeight: 700, paddingBottom: "12px" }}>공급대가</div>
                                <div style={{ fontSize: "14px" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>과세금액</span><span style={{ fontWeight: 700 }}>{receiptPreviewData.taxableAmount}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>부가세</span><span style={{ fontWeight: 700 }}>{receiptPreviewData.vatAmount}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>면세금액</span><span style={{ fontWeight: 700 }}>{receiptPreviewData.taxFreeAmount}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>봉사료</span><span style={{ fontWeight: 700 }}>{receiptPreviewData.serviceAmount}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}><span style={{ fontWeight: 700 }}>총 결제금액</span><span style={{ fontWeight: 700, color: "#f04438", fontSize: "16px" }}>{receiptPreviewData.totalAmount}</span></div>
                                </div>
                                <div style={{ borderBottom: "1px solid #e0e0e0", margin: "14px 0" }} />
                                <div style={{ fontSize: "16px", fontWeight: 700, paddingBottom: "12px" }}>{RECEIPT_LABELS.storeInfo}</div>
                                <div style={{ fontSize: "14px" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>상호명</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.merchantName}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>대표자명</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.merchantOwnerName}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>사업자등록번호</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.merchantBusinessNo}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>이용문의</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.merchantContact}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", gap: "12px" }}><span style={{ color: "#767676", flexShrink: 0 }}>사업장소재지</span><span style={{ fontWeight: 500, textAlign: "right" }}>{receiptPreviewData.merchantAddress}</span></div>
                                </div>
                                <div style={{ borderBottom: "1px solid #e0e0e0", margin: "14px 0" }} />
                                <div style={{ fontSize: "16px", fontWeight: 700, paddingBottom: "12px" }}>{RECEIPT_LABELS.pspInfo}</div>
                                <div style={{ fontSize: "14px" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>상호명</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.supplierName}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>대표자명</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.supplierOwnerName}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>사업자등록번호</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.supplierBusinessNo}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>이용문의</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.supplierContact}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", gap: "12px" }}><span style={{ color: "#767676", flexShrink: 0 }}>사업장소재지</span><span style={{ fontWeight: 500, textAlign: "right" }}>{receiptPreviewData.supplierAddress}</span></div>
                                </div>
                                <div style={{ borderBottom: "1px solid #e0e0e0", margin: "14px 0" }} />
                                <div style={{ fontSize: "16px", fontWeight: 700, paddingBottom: "12px" }}>{RECEIPT_LABELS.pgInfo}</div>
                                <div style={{ fontSize: "14px" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>가맹점명</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.cardMerchantName}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>대표자명</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.cardMerchantOwnerName}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>사업자등록번호</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.cardMerchantBusinessNo}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0" }}><span style={{ color: "#767676" }}>이용문의</span><span style={{ fontWeight: 500 }}>{receiptPreviewData.cardMerchantContact}</span></div>
                                    <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", gap: "12px" }}><span style={{ color: "#767676", flexShrink: 0 }}>사업장소재지</span><span style={{ fontWeight: 500, textAlign: "right" }}>{receiptPreviewData.cardMerchantAddress}</span></div>
                                </div>
                                <div style={{ borderBottom: "1px solid #e0e0e0", margin: "14px 0" }} />
                                <div style={{ fontSize: "11px", color: "#999", lineHeight: 1.5 }}>
                                    <div>본 전표는 이메일 전송용으로 구성된 내역이며, 결제/정산 시스템의 원장과 차이가 있을 수 있습니다.</div>
                                    <div style={{ marginTop: "8px", color: "#666" }}>{RECEIPT_CARD_SMS_NOTICE}</div>
                                </div>
                            </div>
                            <div style={{ borderTop: "1px solid #eee", padding: "20px", background: "#fafafa" }}>
                                <ReceiptImageActions data={receiptPreviewData} viewMode={receiptViewMode} />
                                {/* 전송 방법 선택 */}
                                <div style={{ display: "flex", borderRadius: "8px", overflow: "hidden", border: "1px solid #e5e7eb", marginBottom: "12px" }}>
                                    <button type="button" onClick={() => setSendMethod('email')} style={{ flex: 1, padding: "8px 0", fontSize: "13px", fontWeight: 600, border: "none", background: sendMethod === 'email' ? "var(--brand-primary)" : "#fff", color: sendMethod === 'email' ? "#fff" : "#4e5968", cursor: "pointer" }}>이메일</button>
                                    <button type="button" onClick={() => { if (RECEIPT_SMS_ENABLED) setSendMethod('sms'); }} style={{ flex: 1, padding: "8px 0", fontSize: "13px", fontWeight: 600, border: "none", borderLeft: "1px solid #e5e7eb", borderRight: "1px solid #e5e7eb", background: !RECEIPT_SMS_ENABLED ? "#fff" : sendMethod === 'sms' ? "#00b493" : "#fff", color: !RECEIPT_SMS_ENABLED ? "#adb5bd" : sendMethod === 'sms' ? "#fff" : "#4e5968", cursor: !RECEIPT_SMS_ENABLED ? "not-allowed" : "pointer" }}>{RECEIPT_SMS_ENABLED ? '문자' : '문자(준비중)'}</button>
                                    <button type="button" onClick={() => { if (RECEIPT_KAKAO_ENABLED) setSendMethod('kakao'); }} style={{ flex: 1, padding: "8px 0", fontSize: "13px", fontWeight: 600, border: "none", background: !RECEIPT_KAKAO_ENABLED ? "#fff" : sendMethod === 'kakao' ? "#fee500" : "#fff", color: !RECEIPT_KAKAO_ENABLED ? "#adb5bd" : sendMethod === 'kakao' ? "#3c1e1e" : "#4e5968", cursor: !RECEIPT_KAKAO_ENABLED ? "not-allowed" : "pointer" }}>{RECEIPT_KAKAO_ENABLED ? '카카오톡' : '카카오톡(준비중)'}</button>
                                </div>
                                {sendMethod === 'email' && (
                                    <>
                                        <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#4e5968", marginBottom: "6px" }}>이메일 주소</label>
                                        <input
                                            type="email"
                                            value={receiptModal.emailInput}
                                            onChange={(e) => setReceiptModal((prev) => ({ ...prev, emailInput: e.target.value }))}
                                            autoComplete="off"
                                            placeholder="example@email.com"
                                            onKeyDown={(e) => { if (e.key === "Enter" && !isSendingReceipt) handleConfirmSendReceipt(); }}
                                            style={{ width: "100%", marginBottom: "12px", padding: "10px 12px", borderRadius: "8px", border: "1px solid #d1d5db", fontSize: "14px", outline: "none", boxSizing: "border-box" }}
                                        />
                                    </>
                                )}
                                {sendMethod === 'sms' && (
                                    <>
                                        <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#4e5968", marginBottom: "6px" }}>휴대폰 번호</label>
                                        <input
                                            type="tel"
                                            value={receiptPhone}
                                            onChange={(e) => setReceiptPhone(e.target.value)}
                                            placeholder="01012345678"
                                            onKeyDown={(e) => { if (e.key === "Enter" && !isSendingReceipt) handleConfirmSendReceipt(); }}
                                            style={{ width: "100%", marginBottom: "12px", padding: "10px 12px", borderRadius: "8px", border: "1px solid #d1d5db", fontSize: "14px", outline: "none", boxSizing: "border-box" }}
                                        />
                                    </>
                                )}
                                {sendMethod === 'kakao' && (
                                    <>
                                        <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#4e5968", marginBottom: "6px" }}>휴대폰 번호</label>
                                        <input type="tel" value={receiptPhone} onChange={(e) => setReceiptPhone(e.target.value)} placeholder="01012345678" onKeyDown={(e) => { if (e.key === "Enter" && !isSendingReceipt) handleConfirmSendReceipt(); }} style={{ width: "100%", marginBottom: "12px", padding: "10px 12px", borderRadius: "8px", border: "1px solid #d1d5db", fontSize: "14px", outline: "none", boxSizing: "border-box" }} />
                                    </>
                                )}
                                <div style={{ display: "flex", gap: "8px" }}>
                                    <button type="button" onClick={handleCloseReceiptModal} disabled={isSendingReceipt} style={{ flex: 1, padding: "10px 12px", borderRadius: "8px", border: "none", background: "#e5e7eb", color: "#111827", fontSize: "14px", fontWeight: 600, cursor: isSendingReceipt ? "not-allowed" : "pointer" }}>닫기</button>
                                    <button type="button" onClick={handleConfirmSendReceipt} disabled={isSendingReceipt || (sendMethod === 'sms' && !RECEIPT_SMS_ENABLED) || (sendMethod === 'kakao' && !RECEIPT_KAKAO_ENABLED)} style={{ flex: 1, padding: "10px 12px", borderRadius: "8px", border: "none", background: (sendMethod === 'sms' && !RECEIPT_SMS_ENABLED) || (sendMethod === 'kakao' && !RECEIPT_KAKAO_ENABLED) ? "#e5e7eb" : sendMethod === 'kakao' ? "#fee500" : isSendingReceipt ? "var(--brand-primary-disabled)" : sendMethod === 'sms' ? "#00b493" : "var(--brand-primary)", color: (sendMethod === 'sms' && !RECEIPT_SMS_ENABLED) || (sendMethod === 'kakao' && !RECEIPT_KAKAO_ENABLED) ? "#9ca3af" : sendMethod === 'kakao' ? "#3c1e1e" : "#fff", fontSize: "14px", fontWeight: 600, cursor: isSendingReceipt || (sendMethod === 'sms' && !RECEIPT_SMS_ENABLED) || (sendMethod === 'kakao' && !RECEIPT_KAKAO_ENABLED) ? "not-allowed" : "pointer" }}>
                                        {isSendingReceipt ? "전송중..." : (sendMethod === 'sms' && !RECEIPT_SMS_ENABLED) || (sendMethod === 'kakao' && !RECEIPT_KAKAO_ENABLED) ? "준비중" : sendMethod === 'kakao' ? "알림톡 전송" : sendMethod === 'sms' ? "문자 전송" : "이메일 전송"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: "100%",
                            maxWidth: "768px",
                            height: "100dvh",
                            backgroundColor: "rgba(0,0,0,0.4)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 1000,
                        }}
                        onClick={handleCloseReceiptModal}
                    >
                        <div
                            style={{
                                width: "85%",
                                maxWidth: "400px",
                                backgroundColor: "#FFFFFF",
                                borderRadius: "20px",
                                padding: "28px 24px 20px",
                                boxShadow: "0 10px 25px rgba(15,23,42,0.2)",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div style={{ fontSize: "20px", fontWeight: 600, marginBottom: "16px", color: "#111827" }}>전표 전송</div>
                            {/* 전송 방법 선택 */}
                            <div style={{ display: "flex", borderRadius: "8px", overflow: "hidden", border: "1px solid #e5e7eb", marginBottom: "12px" }}>
                                <button type="button" onClick={() => setSendMethod('email')} style={{ flex: 1, padding: "8px 0", fontSize: "13px", fontWeight: 600, border: "none", background: sendMethod === 'email' ? "var(--brand-primary)" : "#fff", color: sendMethod === 'email' ? "#fff" : "#4e5968", cursor: "pointer" }}>이메일</button>
                                <button type="button" onClick={() => setSendMethod('sms')} style={{ flex: 1, padding: "8px 0", fontSize: "13px", fontWeight: 600, border: "none", borderLeft: "1px solid #e5e7eb", borderRight: "1px solid #e5e7eb", background: sendMethod === 'sms' ? "#00b493" : "#fff", color: sendMethod === 'sms' ? "#fff" : "#4e5968", cursor: "pointer" }}>문자</button>
                                <button type="button" onClick={() => setSendMethod('kakao')} style={{ flex: 1, padding: "8px 0", fontSize: "13px", fontWeight: 600, border: "none", background: sendMethod === 'kakao' ? "#fee500" : "#fff", color: sendMethod === 'kakao' ? "#3c1e1e" : "#4e5968", cursor: "pointer" }}>카카오톡</button>
                            </div>
                            {sendMethod === 'email' && (
                                <>
                                    <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#4e5968", marginBottom: "6px" }}>이메일 주소</label>
                                    <input
                                        type="email"
                                        placeholder="example@email.com"
                                        value={receiptModal.emailInput}
                                        onChange={(e) => setReceiptModal((prev) => ({ ...prev, emailInput: e.target.value }))}
                                        onKeyDown={(e) => { if (e.key === "Enter" && !isSendingReceipt) handleConfirmSendReceipt(); }}
                                        style={{ width: "100%", boxSizing: "border-box", padding: "12px 14px", marginBottom: "16px", fontSize: "15px", border: "1px solid #E5E7EB", borderRadius: "12px", outline: "none" }}
                                    />
                                </>
                            )}
                            {sendMethod === 'sms' && (
                                <>
                                    <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#4e5968", marginBottom: "6px" }}>휴대폰 번호</label>
                                    <input
                                        type="tel"
                                        placeholder="01012345678"
                                        value={receiptPhone}
                                        onChange={(e) => setReceiptPhone(e.target.value)}
                                        onKeyDown={(e) => { if (e.key === "Enter" && !isSendingReceipt) handleConfirmSendReceipt(); }}
                                        style={{ width: "100%", boxSizing: "border-box", padding: "12px 14px", marginBottom: "16px", fontSize: "15px", border: "1px solid #E5E7EB", borderRadius: "12px", outline: "none" }}
                                    />
                                </>
                            )}
                            {sendMethod === 'kakao' && (
                                <>
                                    <label style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#4e5968", marginBottom: "6px" }}>휴대폰 번호</label>
                                    <input type="tel" value={receiptPhone} onChange={(e) => setReceiptPhone(e.target.value)} placeholder="01012345678" onKeyDown={(e) => { if (e.key === "Enter" && !isSendingReceipt) handleConfirmSendReceipt(); }} style={{ width: "100%", boxSizing: "border-box", padding: "12px 14px", marginBottom: "16px", fontSize: "15px", border: "1px solid #E5E7EB", borderRadius: "12px", outline: "none" }} />
                                </>
                            )}
                            <div style={{ display: "flex", gap: "8px" }}>
                                <button
                                    onClick={handleCloseReceiptModal}
                                    disabled={isSendingReceipt}
                                    style={{ flex: 1, padding: "10px 20px", borderRadius: "12px", border: "none", fontSize: "15px", fontWeight: 600, backgroundColor: "#E5E7EB", color: "#111827", cursor: isSendingReceipt ? "not-allowed" : "pointer" }}
                                >
                                    닫기
                                </button>
                                <button
                                    onClick={handleConfirmSendReceipt}
                                    disabled={isSendingReceipt || (sendMethod === 'sms' && !RECEIPT_SMS_ENABLED) || (sendMethod === 'kakao' && !RECEIPT_KAKAO_ENABLED)}
                                    style={{ flex: 1, padding: "10px 20px", borderRadius: "12px", border: "none", fontSize: "15px", fontWeight: 600, backgroundColor: (sendMethod === 'sms' && !RECEIPT_SMS_ENABLED) || (sendMethod === 'kakao' && !RECEIPT_KAKAO_ENABLED) ? "#e5e7eb" : sendMethod === 'kakao' ? "#fee500" : isSendingReceipt ? "var(--brand-primary-disabled)" : sendMethod === 'sms' ? "#00b493" : "#1D4ED8", color: (sendMethod === 'sms' && !RECEIPT_SMS_ENABLED) || (sendMethod === 'kakao' && !RECEIPT_KAKAO_ENABLED) ? "#9ca3af" : sendMethod === 'kakao' ? "#3c1e1e" : "#FFFFFF", cursor: isSendingReceipt || (sendMethod === 'sms' && !RECEIPT_SMS_ENABLED) || (sendMethod === 'kakao' && !RECEIPT_KAKAO_ENABLED) ? "not-allowed" : "pointer" }}
                                >
                                    {isSendingReceipt ? "전송중..." : (sendMethod === 'sms' && !RECEIPT_SMS_ENABLED) || (sendMethod === 'kakao' && !RECEIPT_KAKAO_ENABLED) ? "준비중" : sendMethod === 'kakao' ? "알림톡 전송" : sendMethod === 'sms' ? "문자 전송" : "이메일 전송"}
                                </button>
                            </div>
                        </div>
                    </div>
                )
            )}

            {/* 취소 확인 모달 */}
            {cancelModal.open && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "100%",
                        maxWidth: "768px",
                        height: "100dvh",
                        backgroundColor: "rgba(0,0,0,0.4)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            width: "85%",
                            maxWidth: "400px",
                            backgroundColor: "#FFFFFF",
                            borderRadius: "20px",
                            padding: "28px 24px 20px",
                            boxShadow: "0 10px 25px rgba(15,23,42,0.2)",
                        }}
                    >
                        <div
                            style={{
                                fontSize: "18px",
                                fontWeight: 600,
                                marginBottom: "12px",
                                color: "#111827",
                            }}
                        >
                            취소요청을 하시겠습니까?
                        </div>
                        <div
                            style={{
                                fontSize: "15px",
                                color: "#6B7280",
                                marginBottom: "24px",
                                lineHeight: 1.5,
                            }}
                        >
                            선택한 거래를 취소 처리합니다.
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "8px",
                            }}
                        >
                            <button
                                onClick={handleCloseCancelModal}
                                style={{
                                    flex: 1,
                                    padding: "10px 20px",
                                    borderRadius: "12px",
                                    border: "none",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    backgroundColor: "#E5E7EB",
                                    color: "#111827",
                                    cursor: "pointer",
                                }}
                            >
                                닫기
                            </button>
                            <button
                                onClick={handleConfirmCancel}
                                disabled={cancelBlocked}
                                style={{
                                    flex: 1,
                                    padding: "10px 20px",
                                    borderRadius: "12px",
                                    border: "none",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    backgroundColor: "#DC2626",
                                    color: "#FFFFFF",
                                    cursor: cancelBlocked ? "not-allowed" : "pointer",
                                    opacity: cancelBlocked ? 0.45 : 1,
                                }}
                            >
                                {cancelBlocked ? "취소 불가" : "취소하기"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <footer
                style={{
                    flexShrink: 0,
                    paddingTop: '0.5rem',
                    paddingBottom: '0.5rem',
                    textAlign: 'center',
                    fontSize: '12px',
                    color: '#8b95a1',
                    borderTop: '1px solid #f2f4f6',
                }}
            >
                {BRAND_COPYRIGHT}
            </footer>
        </div>
    );
}

export default AppPaymentList;
